import {
	createRouter,
	createWebHashHistory
} from 'vue-router'

const routes = [{
		path: '/',
		name: '',
		redirect: "/login"
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/Login.vue')
	},
	{
		path: "/userChangePwdApply",
		name: "密码申诉",
		component: () => import('../components/system/userChangePwdApply.vue')
	}, {
		path: "/cer",
		name: "证书管理",
		component: () => import('../components/system/cer.vue')
	},
	{
		path: '/system',
		name: '系统管理',
		component: () => import('../views/System.vue'),
		redirect: "/system/review",
		children: [{
			path: "/system/review",
			component: () => import('../views/Review.vue'),
		}, {
			path: "/system/menu",
			name: "菜单管理",
			component: () => import('../components/system/menu.vue')
		}, {
			path: "/system/roleTable",
			name: "角色管理",
			component: () => import('../components/role/roleTable.vue')
		}, {
			path: "/system/userRole",
			name: "用户角色",
			component: () => import('../components/role/userRole.vue')
		}, {
			path: "/system/userTable",
			name: "用户管理",
			component: () => import('../components/system/userTable.vue'),
		}, {
			path: "/system/userTable/comInfo",
			name: "企业信息",
			component: () => import('../components/company/comInfo.vue')
		}, {
			path: "/system/roleUsersTable",
			name: "角色用户",
			component: () => import('../components/role/roleUsersTable.vue')
		}, {
			path: "/system/industryCategory",
			name: "行业管理",
			component: () => import('../components/company/industryCategory.vue')
		}, {
			path: "/system/regionReview",
			name: "行政区域管理",
			component: () => import('../components/company/regionReview.vue')
		}, {
			path: "/system/companyTable",
			name: "企业信息管理",
			component: () => import('../components/company/companyTable.vue')
		}, {
			path: "/system/companyUserList",
			name: "企业用户管理",
			component: () => import('../components/company/companyUserList.vue')
		}, {
			path: "/system/userInfoTable",
			name: "用户信息管理",
			component: () => import('../components/system/userInfoTable.vue')
		}, {
			path: "/system/pwdVertify",
			name: "密码申诉管理",
			component: () => import('../components/system/pwdVertify.vue')
		}, ]
	}, {
		path: '/sjgl',
		name: '世鉴管理',
		component: () => import('../views/System.vue'),
		redirect: "/system/review",
		children: [{
			path: "/sjgl/result",
			name: "结果公示",
			component: () => import('../components/resultOpen/result.vue')
		}, {
			path: "/sjgl/resultCom",
			name: "结果公布",
			component: () => import('../components/resultOpen/resultCom.vue')
		}, {
			path: "/sjgl/yearsInfo",
			name: "企业公开",
			component: () => import('../components/company/yearsInfo.vue')
		}],
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

export default router
